import * as React from 'react';
import { CheckboxInline } from '@common/components';

interface ZipsProperties {
  readonly checked: boolean;
  readonly zip: string;
  readonly onChange: Function;
  readonly readonly?: boolean;
}
/**
 * Component for zip codes with checkboxes
 *
 * @class Zips
 * @extends {React.PureComponent<ZipsProperties>}
 */
export class Zips extends React.PureComponent<ZipsProperties> {
  render() {
    const { checked, zip, onChange } = this.props;
    return (
      <CheckboxInline>
        {!this.props.readonly && (
          <input
            type="checkbox"
            className="checkbox"
            value={zip}
            checked={checked}
            onChange={e => onChange([e.currentTarget.value])}
          />
        )}
        <label className="ml-5 mr-10" htmlFor="local.disbursed">
          {checked && <i className="fa fa-check-circle" />} {zip}
        </label>
      </CheckboxInline>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-trade-maintenance/trade-zips/_components/zips.component.tsx